import { Navigate } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";

export default function Home() {
  const { me } = useWrapper();
  return me?.type === "Gestor" ? (
    <Navigate to={`/dashboard?nocache=${new Date().getTime()}`} replace />
  ) : me?.type === "Formando" ? (
    <Navigate to={`/formando-dashboard/meus-dados?nocache=${new Date().getTime()}`} replace />
  ) : (
    <Navigate to={`/formando?nocache=${new Date().getTime()}`} replace />
  );
}
